import React, { useContext } from 'react';
import { Button } from 'antd';

import TicketContext from '@totem/components/ticketing/details/ticketContext';

const ButtonCreateExpense = () => {
  const { onAction } = useContext(TicketContext);
  return (
    <Button type="primary" onClick={() => onAction('show-expense-entry', '')}>
      Add Expense
    </Button>
  );
};

export default ButtonCreateExpense;
